import Component from './Component';
import FormComponent from './FormComponent';
import GlobalMessageComponent from './GlobalMessageComponent';
import SelectComponent from './SelectComponent';
import ModalComponent from './ModalComponent';
import DeviceDetection from "../utils/DeviceDetection";
export default class VerificationCapComponent extends Component {
    get SELECTORS() {
        return {
            html: 'html',
            header: 'header',
            stickyBanner: '.sticky-banner',
            heroBanner: '.hero-banner',
            capGeoloc: '.js-cap-geoloc',
            verifyCapForm: 'verifyCapForm',
            verifyCapInput: 'verifyCapInput',
            verifyCityInput: 'verifyCityInput',
            verifyRegionInput: 'verifyRegionInput',
            verificationCapBtn: '.verification-cap-btn',
            verificationCapInfoDom: 'verificationCapInfo',
            verificationCapAddressesDom: 'verificationCapAddresses',
            confirmCapAddress: '.js-confirm-cap-address',
            verificationCapAddAddress: '.js-verification-cap-add-address',
            verificationCapAddAddressContainer: '.js-verification-cap-add-address-container',
            selectAddress: '.js-select-address-local',
            saveVerificationCapAddAddress: '.js-save-verification-cap-address',
            toggleBtn: '#verificationCapPopup .btn',
            saveAddressForm: '.js-save-verification-cap-address-form',
            addressAlert: '.js-address-alert'
        }
    }

    get CLASSES() {
        return {
            hide: 'hide',
            disabled: 'disabled',
            inputOk: 'input-ok',
            inputError: 'input-error'
        }
    }

    get DATA() {
        return {
            logged: 'data-logged',
            CSRFToken: 'data-csrftoken',
            addressName: 'data-address-name'
        }
    }

    get TEMPLATE() {
        return {
            verificationCapAddressTemplate: 'verificationCapAddress--template'

        }
    }

    get LOCAL_STORAGE_ITEMS() {
        return {
            selectedAddress: 'selectedAddress'
        }
    }

    constructor() {
        super();
        this.token = this.getDataAttribute(this.SELECTORS.html, this.DATA.CSRFToken);
        this.ModalComponent = new ModalComponent();
        this.FormComponent = new FormComponent();
        this.SelectComponent = new SelectComponent();
        this.GlobalMessageComponent = new GlobalMessageComponent();
        this.DeviceDetectionUtil = new DeviceDetection();
    }

    showCityInput(toShow) {
        if(toShow) {
            document.getElementById(this.SELECTORS.verifyCityInput).parentNode.classList.remove(this.CLASSES.hide);
        } else {
            document.getElementById(this.SELECTORS.verifyCityInput).parentNode.classList.add(this.CLASSES.hide);
        }
    }

    checkCap() {
        let cap = document.getElementById(this.SELECTORS.verifyCapInput),
            city = document.getElementById(this.SELECTORS.verifyCityInput),
            region = document.getElementById(this.SELECTORS.verifyRegionInput);

        if (!!cap.value && !!city.value) {
            fetch(this.endpoints.CAP_TOWN_VERIFICATION.url + 'postalCode=' + cap.value + '&town=' + city.value, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'CSRFToken': this.token, // This is set on request
                    'Cookie': this.token // This is missing from request
                }
            }).then((response) => response.json()).then((data) => {
                if (data.showPopUp) {
                    this.ModalComponent.openModal(document.getElementById('sessionTimeoutPopup'));
                } else {
                    if (!!data.name) {
                        if (document.getElementById(this.SELECTORS.verifyCityInput).parentNode.classList.contains(this.CLASSES.hide)) {
                            this.FormComponent.createInputError(cap, 'Il tuo CAP è coperto dal servizio Bennet a Casa')
                        } else {
                            this.FormComponent.createInputError(city, 'Il tuo Comune è coperto dal servizio Bennet a Casa')
                        }
                        document.getElementById(this.SELECTORS.verifyCapForm).classList.remove(this.CLASSES.inputError)
                        document.getElementById(this.SELECTORS.verifyCapForm).classList.add(this.CLASSES.inputOk)
                        if(this.getDataAttribute(this.SELECTORS.header, this.DATA.logged) === 'true'){
                            this.getAccountAddresses(cap.value, city.value, region.value);
                        } else {
                            document.getElementById(this.SELECTORS.verificationCapInfoDom).innerHTML = "Il tuo CAP e Comune sono coperti.<br/>Prosegui la tua spesa online e scegli il servizio Bennet a Casa dalla pagina del carrello."
                        }
                        document.querySelector(this.SELECTORS.confirmCapAddress).classList.remove(this.CLASSES.disabled)
                    } else {
                        if (document.getElementById(this.SELECTORS.verifyCityInput).parentNode.classList.contains(this.CLASSES.hide)) {
                            this.FormComponent.createInputError(cap, 'Il tuo CAP non è coperto dal servizio Bennet a Casa')
                        } else {
                            this.FormComponent.createInputError(city, 'Il tuo Comune non è coperto dal servizio Bennet a Casa')
                        }
                        document.getElementById(this.SELECTORS.verifyCapForm).classList.remove(this.CLASSES.inputOk)
                        document.getElementById(this.SELECTORS.verifyCapForm).classList.add(this.CLASSES.inputError)
                        document.querySelector(this.SELECTORS.confirmCapAddress).classList.add(this.CLASSES.disabled)
                        document.getElementById(this.SELECTORS.verificationCapInfoDom).innerText = "Prova con un altro CAP o chiudi per proseguire la navigazione."
                    }
                }
            })
        }
    }

    initCapAutocomplete() {
        const options = {
            componentRestrictions: { country: 'it' },
            types: ['(regions)']
        };

        const capInput = document.getElementById(this.SELECTORS.verifyCapInput),
            cityInput = document.getElementById(this.SELECTORS.verifyCityInput),
            capAutocomplete = new google.maps.places.Autocomplete(capInput, options),
            cityAutocomplete = new google.maps.places.Autocomplete(cityInput, options);

        google.maps.event.addListener(capAutocomplete, 'place_changed', () => {
            let place = capAutocomplete.getPlace();
            this.autoFillInput(place)
        });

        google.maps.event.addListener(cityAutocomplete, 'place_changed', () => {
            let place = cityAutocomplete.getPlace();
            this.autoFillInput(place)
        });
    }

    autoFillInput(result) {
        if (!!result.address_components) {
            let cap, city, region;
            for (var i = 0; i < result.address_components.length; i++) {
                for (var j = 0; j < result.address_components[i].types.length; j++) {
                    if (result.address_components[i].types[j] == "postal_code") {
                        cap = result.address_components[i].long_name;
                    }
                    if (result.address_components[i].types[j] == "administrative_area_level_3") {
                        city = result.address_components[i].long_name;
                    }
                    if (result.address_components[i].types[j] == "administrative_area_level_2") {
                        region = result.address_components[i].short_name;
                    }
                }
            }
            if (!!cap) {
                document.getElementById(this.SELECTORS.verifyCapInput).value = cap;
                document.getElementById(this.SELECTORS.verifyRegionInput).value = region;
            }
            if (!!city) {
                document.getElementById(this.SELECTORS.verifyCityInput).value = city;
            } else {
                this.showCityInput(true);
            }
            this.checkCap();
        }
    }

    geolocation() {
        const ctx = this;

        if (navigator.geolocation) {
            ctx.toggleLoader();
            navigator.geolocation.getCurrentPosition(function (position) {
                let accuracy = position.coords.accuracy;

                if (accuracy < 10000) {
                    window.latitude = position.coords.latitude;
                    window.longitude = position.coords.longitude;
                    new google.maps.Geocoder().geocode({
                        'latLng': new google.maps.LatLng(window.latitude, window.longitude)
                    }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            ctx.autoFillInput(results[0])
                            ctx.showCityInput(true)
                        }
                    });
                } else {
                    ctx.GlobalMessageComponent.renderGlobalMessages('Non è stato possibile impostare la tua posizione in quanto ci risulta bloccata dal browser.', 'info');
                }
                ctx.toggleLoader();
            }, function (error) {
                ctx.log('Error location…');
                ctx.GlobalMessageComponent.renderGlobalMessages('Non è stato possibile impostare la tua posizione in quanto ci risulta bloccata dal browser.', 'info');
                ctx.toggleLoader();
            });
        } else {
            this.log('Geolocation is not supported by your browser');
        }
    }

    cleanVerificationCapPopup(element) {
        if (element.id == this.SELECTORS.verifyCapInput) {
            this.showCityInput(false);
        }
        document.querySelector(this.SELECTORS.confirmCapAddress).classList.add(this.CLASSES.disabled)
        document.querySelector(this.SELECTORS.confirmCapAddress).classList.remove(this.CLASSES.hide)
        document.querySelector(this.SELECTORS.saveVerificationCapAddAddress).classList.add(this.CLASSES.hide);
        document.getElementById(this.SELECTORS.verifyCapForm).classList.remove(this.CLASSES.inputOk)
        document.getElementById(this.SELECTORS.verifyCapForm).classList.remove(this.CLASSES.inputError)
        document.getElementById(this.SELECTORS.verifyCityInput).value = ''
        document.getElementById(this.SELECTORS.verificationCapInfoDom).innerText = ''
        document.getElementById(this.SELECTORS.verificationCapAddressesDom).innerText = ''
        if (!!document.getElementById(this.SELECTORS.verifyCapForm).querySelector('.error-message')) {
            document.getElementById(this.SELECTORS.verifyCapForm).querySelector('.error-message').remove();
        }
    }

    setHeightButton () {
        let headerHeight = document.querySelector(this.SELECTORS.header).offsetHeight,
        stickyHeight = (!!document.querySelector(this.SELECTORS.stickyBanner)) ? document.querySelector(this.SELECTORS.stickyBanner).offsetHeight : 0,
        //searchboxHeight = document.querySelector('.searchbox').offsetHeight,
        bannerHeight = (!!document.querySelector(this.SELECTORS.heroBanner)) ? document.querySelector(this.SELECTORS.heroBanner).offsetHeight : window.innerHeight;

        if (this.DeviceDetectionUtil.detection().isDesktop || this.DeviceDetectionUtil.detection().isTablet) {
            let usefulHeight = window.innerHeight - headerHeight - stickyHeight - bannerHeight - 16;
            if (usefulHeight >=32) {
                document.querySelector(this.SELECTORS.verificationCapBtn).style.bottom = usefulHeight + 'px';
            }
        } /*
        if (this.DeviceDetectionUtil.detection().isMobile) {
            document.querySelector(this.SELECTORS.verificationCapBtn).style.top = headerHeight + searchboxHeight + bannerHeight - 16 + 'px';
        }*/
    }

    getAccountAddresses(postalCode, city, region) {
         fetch(this.endpoints.CART_GET_ACCOUNT_ADDRESSES.url + '?cap=' + postalCode + '&town=' + city, {
        //fetch(this.endpoints.CART_GET_ACCOUNT_ADDRESSES.url + '?cap=' + postalCode, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then((response) => response.json()).then((data) => {
            if (data.showPopUp) {
                this.ModalComponent.openModal(document.getElementById('sessionTimeoutPopup'));
            } else {
                let result = {
                    'addresses': data.filter(address => address.shippingAddress),
                    'cap': postalCode,
                    'district': region
                };
                this.renderMustache(this.TEMPLATE.verificationCapAddressTemplate, document.getElementById(this.SELECTORS.verificationCapAddressesDom), result );
                this.SelectComponent.createSelect();
                if (result.addresses.length > 0) {
                    document.getElementById(this.SELECTORS.verificationCapInfoDom).innerText = "Scegli tra gli indirizzi salvati o aggiungi un nuovo indirizzo a dove consegnare la tua spesa:"
                } else {
                    document.getElementById(this.SELECTORS.verificationCapInfoDom).innerText = "Aggiungi un nuovo indirizzo a dove consegnare la tua spesa:"
                }
            }
        });
    }

    selectAddressForHomeAssociated(address) {
        document.querySelectorAll('.address').forEach(el => {
            el.classList.remove('address--selected')
        })
        address.classList.add('address--selected')
    }

    setLocalStorageAddressForHomeAssociated(newAddress = false) {
        if (newAddress) {
            const  selectedAddress = { 
                'id': newAddress.id, 
                'addressTitle': newAddress.addressTitle
            };
            localStorage.setItem(this.LOCAL_STORAGE_ITEMS.selectedAddress, JSON.stringify(selectedAddress));
        } else if (!!document.querySelector('.address--selected')) {
            const  selectedAddress = { 
                'id': document.querySelector('.address--selected').id, 
                'addressTitle': document.querySelector('.address--selected').getAttribute(this.DATA.addressName)
            };
            localStorage.setItem(this.LOCAL_STORAGE_ITEMS.selectedAddress, JSON.stringify(selectedAddress));
        } else {
            localStorage.removeItem(this.LOCAL_STORAGE_ITEMS.selectedAddress);
        }
    }

    saveNewAddress(target) {
        this.toggleLoader()
        const saveAddressForm = document.querySelector(this.SELECTORS.saveAddressForm);
        saveAddressForm.querySelector('input[name="line1"]').value = document.getElementById(`street-select-temp`).value + ', ' + saveAddressForm.querySelector('input[name="numeroCivico"]').value
        saveAddressForm.querySelector('input[name="townCity"]').value = document.getElementById(`town-select-temp`).value;
        fetch(this.endpoints.ACCOUNT_ADD_ADDRESS.url, {
            method: 'post',
            body: new URLSearchParams(Array.from(new FormData(saveAddressForm))),
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded',
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then((response) => response.json()).then((data) => {
            if (data.showPopUp) {
                this.toggleLoader()
                this.ModalComponent.openModal(document.getElementById('sessionTimeoutPopup'));
            } else {
                if (data && data.line1 != null) {
                    this.setLocalStorageAddressForHomeAssociated(data)
                    this.ModalComponent.closeModal();
                    document.querySelectorAll(this.SELECTORS.toggleBtn).forEach(btn => {
                        btn.classList.toggle(this.CLASSES.hide);
                    })
                    this.checkCap();
                } else {
                    saveAddressForm.querySelector(this.SELECTORS.addressAlert).classList.remove(this.CLASSES.hide);
                }
                this.toggleLoader()
            }
        })
    }

    bindEvents() {
        this.setHeightButton();

        window.addEventListener('resize', () => this.setHeightButton());
        
        document.getElementById(this.SELECTORS.verifyCapForm).querySelectorAll('input').forEach(input => {
            input.addEventListener('focus', (e) => {
                this.cleanVerificationCapPopup(e.target);
            })
        });

        document.getElementById(this.SELECTORS.verifyCapInput).addEventListener('keydown', (e) => {
            this.cleanVerificationCapPopup(e.target);
        });

        this.events.on('click', this.SELECTORS.capGeoloc, (e) => {
            this.geolocation();
        });

        document.getElementById(this.SELECTORS.verifyCapForm).addEventListener('submit', (e) => {
            e.preventDefault();
            e.stopPropagation();
            document.getElementById(this.SELECTORS.verificationCapInfoDom).innerText = "Seleziona un’opzione tra quelle proposte."
        });

        this.events.on('submit', this.SELECTORS.saveAddressForm, (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.saveNewAddress(e.target);
        });

        this.events.on('click', this.SELECTORS.verificationCapAddAddress, (e) => {
            document.querySelector('.cart-address-edit').classList.toggle(this.CLASSES.hide);
        });

        this.events.on('click', this.SELECTORS.selectAddress, (e) => {
            const element = e.target.matches(this.SELECTORS.selectAddress) ? e.target : e.target.closest(this.SELECTORS.selectAddress);
            this.selectAddressForHomeAssociated(element);
        });

        this.events.on('click', this.SELECTORS.confirmCapAddress, (e) => {
            this.setLocalStorageAddressForHomeAssociated();
        });

        this.events.on('click', this.SELECTORS.verificationCapAddAddress, (e) => {
            document.querySelectorAll(this.SELECTORS.toggleBtn).forEach(btn => {
                btn.classList.toggle(this.CLASSES.hide);
            })
        });
    }

    render() {
        this.log('render Verification Cap');
        this.bindEvents();
    }
}